module.exports = __webpack_public_path__ + "img/edit-selected.e445ce53.png";